// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>21</span>&nbsp;&nbsp;You know my reproach, my shame and my dishonour;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my adversaries are all in your sight.<br> </p> </div></div>";
// Exports
module.exports = code;